<div class="auth-layout-wrap">
    <router-outlet></router-outlet>
</div>
